/* MOLLO — transitions douces entre fonds blanc et bleu nuit : chevauchement arrondi + fondu d'apparition, sans bloquer le défilement */
(function () {
  if (window.__moStack) return; window.__moStack = true;
  var DARK = '.mo-gain, .mo-life, .mo-prom, .mo-dark, .mo-foot';
  function sec(el) { return el.closest('.shopify-section') || el; }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-on'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 }) : null;
  function setup() {
    var targets = [];
    document.querySelectorAll(DARK).forEach(function (d) {
      var w = sec(d);
      if (targets.indexOf(w) < 0) targets.push(w);
      var n = w.nextElementSibling;
      if (n && n.classList.contains('shopify-section') && !n.querySelector(DARK + ', .mo-marquee') && targets.indexOf(n) < 0) targets.push(n);
    });
    targets.forEach(function (t) {
      if (t.classList.contains('mo-stack')) return;
      t.classList.add('mo-stack');
      if (io) io.observe(t); else t.classList.add('is-on');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', function () { setTimeout(setup, 50); });
})();
